import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { queryKeys } from "@/modules/api/queryKeys";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { getRankingQuery } from "@/modules/ranking/api/queries/getRankingQuery";
import { useUserDataContext } from "@/modules/user/hooks/useUserDataContext";

import { parseRankingResponse } from "./parseRankingResponse";

const translationNamespace = "apiMessages/useGetRankingQuery";

export function useGetRankingQuery() {
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  const { currentGroup } = useUserDataContext();
  return useQuery(
    currentGroup
      ? {
          queryKey: [queryKeys.ranking.getRankingList, currentGroup],
          queryFn: () =>
            getRankingQuery(jsonApi, {
              userGroupId: currentGroup.id,
            }),
          retry: false,
          refetchOnWindowFocus: false,
          select: (response) => {
            if (response) {
              return parseRankingResponse(response);
            }
          },
          onError: (error) => {
            apiErrorValidate(error, {
              401: {
                UNAUTHORIZED: t(
                  "You are not allowed to view ranking. Please sign in again"
                ),
              },
              403: {
                ACCESS_FORBIDDEN: t("You don't have an access to view ranking"),
              },
            });
          },
        }
      : { enabled: false }
  );
}
